(() => {
  if (customElements.get('mc-upsell-gallery')) return;
  class MCUpsellGallery extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      const { signal } = this.controller = new AbortController();
      this.track = this.querySelector('.mc-upsell-gallery__track');
      this.dots = this.querySelector('.mc-upsell-gallery__dots');
      const slides = [...this.track.children];
      this.dots.replaceChildren(...slides.map((slide, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', `Photo ${index + 1} of ${slides.length}`);
        button.addEventListener('click', event => { event.stopPropagation(); this.goTo(index); }, { signal });
        return button;
      }));
      this.dots.hidden = slides.length < 2;
      this.index = 0;
      this.track.addEventListener('scroll', () => {
        this.index = Math.round(Math.abs(this.track.scrollLeft) / (this.track.clientWidth || 1));
        this.update();
      }, { passive: true, signal });
      let gesture;
      let dragged = false;
      this.track.addEventListener('pointerdown', event => {
        dragged = false;
        if (event.button !== 0) return;
        gesture = { x: event.clientX, y: event.clientY, left: this.track.scrollLeft, mouse: event.pointerType === 'mouse' };
      }, { signal });
      this.track.addEventListener('pointermove', event => {
        if (!gesture) return;
        const dx = event.clientX - gesture.x;
        if (Math.abs(dx) < 6 || Math.abs(dx) < Math.abs(event.clientY - gesture.y)) return;
        dragged = true;
        if (gesture.mouse) {
          event.preventDefault();
          this.track.setPointerCapture(event.pointerId);
          this.track.classList.add('is-dragging');
          this.track.scrollLeft = gesture.left - dx;
        }
      }, { signal });
      const stop = () => { gesture = null; this.track.classList.remove('is-dragging'); };
      this.track.addEventListener('pointerup', stop, { signal });
      this.track.addEventListener('pointercancel', stop, { signal });
      this.track.addEventListener('lostpointercapture', stop, { signal });
      this.track.addEventListener('dragstart', event => event.preventDefault(), { signal });
      this.track.addEventListener('click', event => {
        if (dragged && event.detail !== 0) { event.preventDefault(); event.stopPropagation(); }
      }, { capture: true, signal });
      this.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal });
      this.resize = new ResizeObserver(() => this.goTo(this.index, false));
      this.resize.observe(this.track);
      this.update();
    }
    goTo(index, smooth = true) {
      this.index = Math.max(0, Math.min(index, this.track.children.length - 1));
      const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
      this.track.scrollTo({ left: direction * this.index * this.track.clientWidth, behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
      this.update();
    }
    update() {
      [...this.dots.children].forEach((button, index) => button.setAttribute('aria-current', String(index === this.index)));
      [...this.track.children].forEach((slide, index) => { slide.tabIndex = index === this.index ? 0 : -1; });
    }
    disconnectedCallback() { this.controller?.abort(); this.resize?.disconnect(); }
  }
  customElements.define('mc-upsell-gallery', MCUpsellGallery);
})();
